/* eslint-disable no-unused-vars */
import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import { MemberInfo } from "../../api/ApplicationApi";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";

class MembersStore {
  private _api: ApiStore;
  isLoadMemders: boolean = false;
  members: MemberInfo[] = [];

  memberInfoByAccount: {
    key: string;
    members: MemberInfo[];
  }[] = [];

  constructor(api: ApiStore) {
    makeAutoObservable(this);
    this._api = api;
  }
  setIsLoading = (status: boolean): void => {
    this.isLoadMemders = status;
  };
  initMember(members: any, createCuid?: boolean): MemberInfo[] {
    return members?.map((member: any) => {
      if (createCuid)
        if (!member.key) {
          member.key = uuidv4();
        }
      if (!member.committeeMemberKey) {
        member.committeeMemberKey = 0;
      }
      member.isDisabledAccount = false;
      if (member.committeeMemberKey !== 0) {
        member.isDisabledAccount = true;
      }
      if (!member.committeeKey) {
        member.committeeKey = 0;
      }
      if (!member.residentKey) {
        member.residentKey = "";
      }
      if (!member.residentContactKey) {
        member.residentContactKey = "";
      }
      if (!member.cm_Name) {
        member.cm_Name = "";
      }
      if (!member.firstName) {
        member.firstName = "";
      }
      if (!member.lastName) {
        member.lastName = "";
      }
      if (!member.cm_Title) {
        member.cm_Title = "";
      }
      if (!member.cm_WebEmail) {
        member.cm_WebEmail = "";
      }
      if (!member.termStr) {
        member.termStr = "";
      }
      if (!member.termLength) {
        member.termLength = "";
      }
      if (!member.termStartStr) {
        member.termStartStr = "";
      } else {
        member.termStartStrPicker = dayjs(member.termStartStr, "YYYY-MM-DD");
      }
      if (!member.termEndStr) {
        member.termEndStr = "";
      } else {
        member.termEndStrPicker = dayjs(member.termEndStr, "YYYY-MM-DD");
      }
      if (!member.streetNumber) {
        member.streetNumber = "";
      }
      if (!member.streetName) {
        member.streetName = "";
      }
      if (!member.city) {
        member.city = "";
      }
      if (!member.state) {
        member.state = "";
      } else {
        member.state = member.state.trim();
      }
      if (!member.zip) {
        member.zip = "";
      }
      if (!member.cm_SendFinancial) {
        member.cm_SendFinancial = false;
      }
      if (!member.committeeMemberContactKey) {
        member.committeeMemberContactKey = 0;
      }
      if (!member.cmc_Type) {
        member.cmc_Type = "";
      }
      if (!member.cmc_Telephone) {
        member.cmc_Telephone = "";
      }
      if (!member.cmc_Email) {
        member.cmc_Email = "";
      }
      if (member.isEmailConfirmed === undefined || member.isEmailConfirmed === null) {
        member.isEmailConfirmed = false;
      }
      if (!member.finCEN) {
        member.finCEN = "";
      }
      if (!member.dateSubmittedFinCenStr) {
        member.dateSubmittedFinCenStr = "";
      } else {
        member.dateSubmittedFinCenStrPicker = dayjs(
          member.dateSubmittedFinCenStr,
          "YYYY-MM-DD"
        );
      }

      return member;
    });
  }
  async loadMembers(comiteeId: string, saveNew: any = null): Promise<void> {
    console.log("loadMembers", saveNew);
    let newArr: any[] = [];
    if (saveNew) {
      newArr = this.members.filter((m) => {
        return m.committeeMemberKey == 0;
      });
    }
    if (!Array.isArray(newArr)) {
      newArr = [];
    }
    this.isLoadMemders = true;
    this._api.api
      .getMembers(comiteeId || "")
      .then((response) => {
        console.log(response);
        this.members = this.initMember(newArr.concat(response.data), true);
        this.isLoadMemders = false;
      })
      .catch((err) => {
        this.isLoadMemders = false;

        console.log(err);
      });
  }

  addMember(): void {
    this.members = this.initMember([{} as MemberInfo, ...this.members], true);
  }

  editMember(key: string, data: Record<any, any>): void {
    this.members = this.members.map((_) => {
      if (_.key === key) {
        return {
          ..._,
          ...data,
        };
      } else {
        return _;
      }
    });
  }

  /** Context from current property/committee selection; used to fill required API fields when missing on member. */
  saveMember(
    key: string,
    context?: {
      committeeName: string;
      propertyName: string;
      groupName: string;
      committeeKey: number;
    },
    onValidationError?: (message: string) => void
  ): void {
    const member = this.members.find((_) => _.key === key);
    if (!member) return;

    const committeeName = (member.committeeName?.trim() || context?.committeeName?.trim() || "").trim();
    const propertyName = (member.propertyName?.trim() || context?.propertyName?.trim() || "").trim();
    const groupName = (member.groupName?.trim() || context?.groupName?.trim() || "").trim();
    const committeeKey = (member.committeeKey && member.committeeKey !== 0)
      ? member.committeeKey
      : (context?.committeeKey ?? 0);

    if (!committeeName || !propertyName || !groupName) {
      const missing = [
        !committeeName && "Committee Name",
        !propertyName && "Property Name",
        !groupName && "Group Name",
      ]
        .filter(Boolean)
        .join(", ");
      const msg = `Cannot save: ${missing} are required. Please select a property and committee/group first.`;
      onValidationError?.(msg);
      console.error(msg);
      return;
    }

    if (!committeeKey) {
      const msg = "Cannot save: Committee is not selected. Please select a committee/group first.";
      onValidationError?.(msg);
      console.error(msg);
      return;
    }

    // Derive API date strings from pickers (form uses termStartStrPicker/termEndStrPicker; API requires termStartStr/termEndStr and termStartDbStr/termEndDbStr)
    const termStartStr = (() => {
      const v = member.termStartStrPicker;
      if (v && dayjs(v).isValid()) return dayjs(v).format("YYYY-MM-DD");
      return (member.termStartStr || "").trim();
    })();
    const termEndStr = (() => {
      const v = member.termEndStrPicker;
      if (v && dayjs(v).isValid()) return dayjs(v).format("YYYY-MM-DD");
      return (member.termEndStr || "").trim();
    })();

    const memberWithContext = {
      ...member,
      committeeName,
      propertyName,
      groupName,
      committeeKey,
      termStartStr,
      termEndStr,
      termStartDbStr: termStartStr,
      termEndDbStr: termEndStr,
    };

    const dataObj = new FormData();
    const fidsSkip = [
      "dateSubmittedFinCenDBStr",
      "dateAppointedDBStr",
      "termStartStrPicker",
      "termEndStrPicker",
    ];
    const toFormValue = (val: unknown): string => {
      if (val === null || val === undefined) return "";
      if (typeof val === "string") return val;
      if (typeof val === "object" && typeof (val as any).format === "function") {
        return (val as any).format("YYYY-MM-DD");
      }
      return String(val);
    };
    Object.keys(memberWithContext).forEach((k) => {
      if (!fidsSkip.find((_) => _ === k)) {
        let data = memberWithContext[k as keyof MemberInfo];
        if (data === null || (!data && typeof data === "string")) {
          data = "";
        }
        dataObj.append(k, toFormValue(data));
      }
    });
    // Ensure residentKey and cmc_Telephone are always sent (form fields the API expects)
    dataObj.set("residentKey", toFormValue(memberWithContext.residentKey));
    dataObj.set("cmc_Telephone", toFormValue(memberWithContext.cmc_Telephone));

    this._api.api
      .addMemberAsync(dataObj)
      .then((res) => {
        console.log(res);
        this.loadMembers(committeeKey.toString()).catch(console.log);
      })
      .catch(console.error);
  }

  getMemberInfoByAccount(key: string, propertyId: number): void {
    const member = this.members.find((_) => _.key === key);

    const accountId = member?.residentKey;

    const exist = this.memberInfoByAccount.find((_) => _.key === key);
    if (exist) {
      this.memberInfoByAccount = this.memberInfoByAccount.filter(
        (_) => _.key !== key
      );
    }
    if (accountId)
      this._api.api
        .getMemberInfoByAccountNumAsync(propertyId, accountId)
        .then((res) => {
          console.log(res);
          if (res.data && res.data.length > 0) {
            const existMembers = this.memberInfoByAccount.find(
              (_) => _.key === key
            );
            if (existMembers) {
              this.memberInfoByAccount = this.memberInfoByAccount.map((_) => {
                if (_.key === key) {
                  _.members = this.initMember([...res.data], false);
                }
                return _;
              });
            } else {
              this.memberInfoByAccount = [
                ...this.memberInfoByAccount,
                { key: key, members: this.initMember([...res.data], false) },
              ];
            }
          } else {
            this.memberInfoByAccount = [
              ...this.memberInfoByAccount,
              { key: key, members: [] },
            ];
          }
        })
        .catch(console.error);
  }

  removeMember(key: string): void {
    if (key) {
      const member = this.members.find((_) => _.key === key);
      if (member && member.committeeMemberKey) {
        this._api.api
          .removeMemberAsync(member.committeeMemberKey, member.employeeKey)
          .then((res) => {
            console.log(res);
            this.loadMembers(member.committeeKey.toString()).catch(console.log);
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.members = this.members.filter((_) => _.key !== key);
      }
    }
  }
}
export default MembersStore;